import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingSpinner from "../../../components/LoadingSpinner/index";
import { getUserKasms, getUserImages, clearSearch } from "../../../actions/actionDashboard";
import ListKasms from "./ListKasms";
import { Col, Row, Card, Progress} from "reactstrap";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import Proptypes from "prop-types";
import { logout, logoutControlled } from "../../../actions/actionLogin";
import {
    IS_ANONYMOUS,
    DASHBOARD_REDIRECT,
    REQUIRE_SUBSCRIPTION,
    HAS_SUBSCRIPTION
} from "../../../constants/Constants.js";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: true},
];

class UserDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            kasmID:""
        };
    }

    UNSAFE_componentWillMount(){
        let dashboard_redirect = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).dashboard_redirect;
        if (dashboard_redirect){
            this.props.logoutControlled().then(() => {
                window.location.href = dashboard_redirect;
            }).catch(() => {
                window.location.href = dashboard_redirect;
            });

        }

        let require_subscription = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).require_subscription;
        let has_subscription = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).has_subscription;
        if (require_subscription && !has_subscription){
            window.location.href = "/#/subscribe";
        }
    }

    componentDidMount() {
        const userInfo = JSON.parse(window.localStorage.user_info);
        const payload_data = {
            "token": userInfo.token,
            "username": userInfo.username
        };
        this.props.kasmsFunc(payload_data);
        this.props.imageFunc(payload_data);
        this.props.clearSearch();
    }

    render() {
        if (IS_ANONYMOUS === false) {
            if (this.props.getuserkasmsLoading) {
                return (<div><LoadingSpinner/></div>);
            }

            return (
                <div>
                    <BreadCrumbCompo routes={routes}/>
                    <Row>
                        <Col sm={{size: 12, order: 0, offset: 0}}>
                            <ListKasms kasmID={this.state.kasmID}/>
                        </Col>
                    </Row>
                </div>
            );
        }
        else{
             return ("");
        }
    }
}


UserDashboard.propTypes = {
    imageFunc: Proptypes.func.isRequired,
    kasmsFunc: Proptypes.func.isRequired,
    clearSearch: Proptypes.func.isRequired,
    liveKasms: Proptypes.array,
    availableKasms: Proptypes.array,
    getuserkasmsLoading: Proptypes.bool,
    history: Proptypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        isLoggedIn: state.auth.isLoggedIn,
        loginError: state.dashboard.loginError,
        availableKasms: state.dashboard.availableKasms,
        liveKasms: state.dashboard.liveKasms,
        getuserkasmsLoading: state.dashboard.getuserkasmsLoading
    };
}

function mapDispatchToProps(dispatch) {
    return {
        imageFunc: (payload_data) => {dispatch(getUserImages(payload_data));},
        kasmsFunc: (payload_data) => {dispatch(getUserKasms(payload_data));},
        clearSearch: () => { dispatch(clearSearch())},
        logout: (logout_data) => {dispatch(logout(logout_data));},
        logoutControlled: (logout_data) => dispatch(logoutControlled(logout_data))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserDashboard);
